/**
 * @file    useFeatureFlagResolver.ts
 * @scope   SHARED
 * @summary Hook that binds the engine flag resolver to the global store's `configDashboard`.
 * @consumes useStore (configDashboard), createFeatureFlagResolver
 * @produces useFeatureFlagResolver
 * @sideEffects None (localStorage is read lazily on each call, so overrides apply on next render).
 * @notes   Memoized on `configDashboard` so the returned function is referentially stable.
 */
import { useMemo } from 'react';
import { useStore } from 'store/useGlobalStore';
import { createFeatureFlagResolver, FeatureFlagSource } from './resolveFeatureFlag';

export const useFeatureFlagResolver = (): ((flag?: string) => boolean) => {
  const configDashboard = useStore((state) => state.configDashboard);
  return useMemo(
    () => createFeatureFlagResolver(configDashboard as unknown as FeatureFlagSource),
    [configDashboard]
  );
};
